import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";

function NtCaseStudyText({ style, ...otherProbs }) {
  return <NtText style={[styles.text, style]} {...otherProbs} />;
}

const styles = StyleSheet.create({
  container: {},
  text: {
    color: "white",
    fontSize: 15,
    fontWeight: "400",
    lineHeight: 22,
  },
});

export default NtCaseStudyText;
